import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import onegatIcon from "../assets/icons/onegat.webp";
import onegat_menuIcon from "../assets/icons/onegat_menu.webp";
import registroColoniasImg from "../assets/icons/registro_colonias.webp";
import esterilizacionImg from "../assets/icons/esterilizacion.webp";
import mediacionVecinalImg from "../assets/icons/mediacion_vecinal.webp";

const HomePreview = () => {
  useEffect(() => {
    const header = document.querySelector("header");
    if (header) header.style.display = "none";

    return () => {
      if (header) header.style.display = "block";
    };
  }, []);

  return (
    <div className="container py-5">

      {/* Header Minimalista */}
      <header className="bg-white shadow-sm fixed-top py-3">
        <div className="container d-flex justify-content-between align-items-center">
          {/* Logo y Nombre */}
          <div className="d-flex align-items-center">
            <img src={onegat_menuIcon} alt="Logo" style={{ width: "40px", height: "40px", marginRight: "10px" }} />
          </div>

          {/* Menú de Navegación */}
          <nav>
            <ul className="nav">
              <li className="nav-item">
                <a className="nav-link text-dark fw-bold" href="/quienes-somos">Quiénes Somos</a>
              </li>
              <li className="nav-item">
                <a className="nav-link text-dark fw-bold" href="/contacto">Contacto</a>
              </li>
              {/*<li className="nav-item">
                <a className="nav-link text-primary fw-bold" href="/demo">Probar la demo</a>
              </li>*/}
            </ul>
          </nav>
        </div>
      </header>

      {/* HERO */}
      <section className="row align-items-center mb-5">
        <div className="col-lg-7 text-center text-lg-start">
          <h1 className="display-5 fw-bold mb-3"
           style={{
              fontSize: "1.5rem",
              letterSpacing: "0px",
            }}
          >
            ONEGAT: software para la gestión digital de colonias felinas bajo el método CES
          </h1>
          <p className="lead text-muted">
            Una herramienta tecnológica para ayuntamientos que buscan organizar de forma segura,
            clara y centralizada la información sobre colonias felinas.
          </p>
          <div className="d-flex flex-column flex-sm-row gap-3 mt-4 justify-content-center justify-content-lg-start">
            <Link to="/contacto" className="btn btn-outline-primary btn-lg px-4">
              Solicitar acceso a la demo
            </Link>
            <Link to="/quienes-somos" className="btn btn-outline-secondary btn-lg px-4">
              Saber más sobre Onegat
            </Link>
          </div>
          <p className="text-muted mt-3" style={{ fontSize: "0.9rem" }}>
            Acceso supervisado a un entorno de pruebas. Sin compromiso.
          </p>
        </div>
        <div className="col-lg-5 text-center mt-4 mt-lg-0">
          <img
            src={onegatIcon}
            alt="Onegat"
            className="shadow-lg"
            style={{ width: "260px", height: "260px", borderRadius: "20px", objectFit: "cover" }}
          />
        </div>
      </section>

      {/* DESCRIPCIÓN CORTA */}
      <section className="row mb-5">
        <div className="col-lg-10 mx-auto">
          <div className="p-4 p-md-5 bg-light rounded-4 shadow-sm">
            <h2 className="h4 fw-bold mb-3">¿Qué es ONEGAT?</h2>
            <p className="mb-0 text-muted" style={{ lineHeight: 1.8 }}>
              ONEGAT es una aplicación informática (SaaS) desarrollada para digitalizar la trazabilidad de colonias felinas
              gestionadas bajo el método CES. Permite registrar colonias y animales, documentar actuaciones y generar
              informes de manera estructurada, ágil y segura.
              Es una herramienta puramente tecnológica, diseñada para facilitar la organización de datos por parte de las
              entidades que la utilicen.
            </p>
          </div>
        </div>
      </section>

      {/* BENEFICIOS */}
      <section className="mb-5">
        <h2 className="h4 fw-bold text-center mb-4">Beneficios principales</h2>
        <div className="row g-4">
          <div className="col-md-4">
            <div className="card h-100 shadow-sm border-0">
              <img
                src={registroColoniasImg}
                alt="Organización de colonias"
                className="card-img-top"
                style={{ height: "180px", objectFit: "cover", borderRadius: "10px 10px 0 0" }}
              />
              <div className="card-body">
                <h5 className="card-title fw-bold">Organización clara y unificada</h5>
                <p className="card-text text-muted" style={{ fontSize: "0.95rem" }}>
                  Toda la información sobre colonias, animales y actuaciones CES centralizada en un mismo sistema,
                  accesible desde cualquier dispositivo autorizado.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card h-100 shadow-sm border-0">
              <img
                src={esterilizacionImg}
                alt="Eficiencia en el registro"
                className="card-img-top"
                style={{ height: "180px", objectFit: "cover", borderRadius: "10px 10px 0 0" }}
              />
              <div className="card-body">
                <h5 className="card-title fw-bold">Mayor eficiencia en el registro</h5>
                <p className="card-text text-muted" style={{ fontSize: "0.95rem" }}>
                  Fichas estructuradas de colonias, animales y actuaciones que permiten un acceso rápido,
                  ordenado y trazable a la información relevante.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card h-100 shadow-sm border-0">
              <img
                src={mediacionVecinalImg}
                alt="Informes automáticos"
                className="card-img-top"
                style={{ height: "180px", objectFit: "cover", borderRadius: "10px 10px 0 0" }}
              />
              <div className="card-body">
                <h5 className="card-title fw-bold">Informes automáticos y trazabilidad</h5>
                <p className="card-text text-muted" style={{ fontSize: "0.95rem" }}>
                  Generación de informes exportables sobre intervenciones, censos y actividad registrada,
                  con historial de actuaciones, fechas y usuarios que intervienen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FUNCIONALIDADES */}
      <section className="mb-5">
        <h2 className="h4 fw-bold text-center mb-4">Funcionalidades principales</h2>
        <div className="row g-4">
          <div className="col-md-6">
            <ul className="list-group list-group-flush shadow-sm rounded-4">
              <li className="list-group-item">
                Registro de colonias: localización, responsables y número de animales.
              </li>
              <li className="list-group-item">
                Fichas individuales de gatos: datos básicos, estado y actuaciones realizadas.
              </li>
              <li className="list-group-item">
                Gestión de actuaciones CES: captura, esterilización, suelta y observaciones.
              </li>
              <li className="list-group-item">
                Panel de control con indicadores básicos de actividad registrada.
              </li>
              <li className="list-group-item">
                Perfiles de usuario con permisos diferenciados según rol.
              </li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul className="list-group list-group-flush shadow-sm rounded-4">
              <li className="list-group-item">
                Historial detallado de cambios y acciones realizadas en la plataforma.
              </li>
              <li className="list-group-item">
                Exportación de informes para uso interno de la entidad.
              </li>
              <li className="list-group-item">
                Infraestructura independiente para cada entidad (arquitectura multi-tenant).
              </li>
              <li className="list-group-item">
                Medidas técnicas orientadas a la seguridad y protección frente a accesos no autorizados.
              </li>
              <li className="list-group-item">
                Actualizaciones continuas incluidas en la licencia de uso.
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* PLATAFORMA WEB + APLICACIÓN MÓVIL */}
      <section className="my-5">
        <div
          className="p-4 p-md-5 rounded-4 shadow-sm"
          style={{ background: "#f8fafc" }}
        >
          <div className="row g-4 align-items-center">
            <div className="col-lg-7">
              <span
                className="text-uppercase fw-semibold d-inline-block mb-2"
                style={{ fontSize: "0.8rem", letterSpacing: "0.15em", color: "#6c757d" }}
              >
                Plataforma web + app móvil
              </span>

              <h2 className="h4 fw-bold mb-3">
                Una aplicación móvil vinculada a cada municipio
              </h2>

              <p className="text-muted mb-2" style={{ lineHeight: 1.8 }}>
                Además de la plataforma web, <strong>ONEGAT</strong> dispone de una
                aplicación móvil (APK Android) específica para cada municipio, pensada
                para registrar información directamente sobre el terreno desde móvil o tablet.
              </p>

              <p className="text-muted mb-2" style={{ lineHeight: 1.8 }}>
                En la fase actual, la app permite la creación de nuevos gatos, vinculándolos
                a la colonia correspondiente y sincronizando los datos con el entorno web
                del municipio.
              </p>

              <p className="text-muted mb-3" style={{ lineHeight: 1.8 }}>
                La aplicación está concebida como un complemento en evolución: a medida que
                la solución se consolide, está previsto valorar la incorporación de nuevos
                módulos, como el registro de incidencias internas u otros que se definan
                junto con las entidades usuarias.
              </p>

              <div className="d-flex flex-wrap gap-2 mt-2">
                <span className="badge rounded-pill text-bg-primary">Registro en campo</span>
                <span className="badge rounded-pill text-bg-light border">Sincronización con la web</span>
                <span className="badge rounded-pill text-bg-light border">APK por municipio</span>
                <span className="badge rounded-pill text-bg-secondary">Evolución por módulos</span>
              </div>
            </div>

            <div className="col-lg-5 text-center">
              <div
                className="d-inline-block px-4 py-5 rounded-4"
                style={{
                  background: "white",
                  boxShadow: "0 18px 45px rgba(15, 23, 42, 0.08)",
                }}
              >
                {/* Mockup sencillo tipo móvil */}
                <div
                  className="mx-auto mb-3"
                  style={{
                    width: "170px",
                    height: "340px",
                    borderRadius: "32px",
                    border: "1px solid #e5e7eb",
                    padding: "12px",
                    background: "#f9fafb",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={onegatIcon}
                    alt="ONEGAT app"
                    style={{
                      width: "90%",
                      height: "90%",
                      borderRadius: "24px",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
                  Vista conceptual de la app móvil vinculada al entorno web de cada municipio.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PARA QUIÉN ESTÁ PENSADO */}
      <section className="my-5 pt-5">
        <h2 className="h4 fw-bold text-center mb-3">¿Para quién está pensado ONEGAT?</h2>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <p className="text-muted text-center" style={{ lineHeight: 1.8 }}>
              ONEGAT está diseñado para ayuntamientos que aplican el método CES y necesitan estructurar la información,
              así como para asociaciones y entidades colaboradoras que desean trabajar con datos ordenados y trazables.
            </p>
            <p className="text-muted text-center mt-3" style={{ lineHeight: 1.8 }}>
              La plataforma se adapta a diferentes realidades municipales, independientemente del tamaño del municipio,
              ofreciendo una solución tecnológica sencilla y segura para gestionar la información relacionada con colonias felinas.
            </p>
          </div>
        </div>
      </section>

      {/* TRANSICIÓN / SEPARADOR */}
      <section className="mb-4">
        <div className="d-flex align-items-center justify-content-center">
          <div
            style={{
              height: "1px",
              width: "80px",
              background: "linear-gradient(90deg, rgba(0,0,0,0), rgba(0,0,0,0.15))",
            }}
          />
          <span
            className="mx-3 text-uppercase fw-semibold"
            style={{ fontSize: "0.8rem", letterSpacing: "0.15em", color: "#888" }}
          >
            Casos de uso típicos
          </span>
          <div
            style={{
              height: "1px",
              width: "80px",
              background: "linear-gradient(90deg, rgba(0,0,0,0.15), rgba(0,0,0,0))",
            }}
          />
        </div>
      </section>

      {/* CASOS DE USO TÍPICOS */}
      <section className="mb-5">
        <div className="row g-4">
          {/* Caso 1 */}
          <div className="col-md-6">
            <div className="h-100 p-4 bg-light rounded-4 shadow-sm">
              <h5 className="fw-bold mb-2">
                1. Municipios que necesitan centralizar la información dispersa
              </h5>
              <p className="text-muted mb-0" style={{ lineHeight: 1.7, fontSize: "0.95rem" }}>
                En muchos ayuntamientos la información de colonias felinas se encuentra repartida entre
                archivos, documentos sueltos, correos y hojas de cálculo mantenidas por diferentes personas.
                Esto dificulta el seguimiento de actuaciones y la trazabilidad.
                <br />
                <strong>ONEGAT</strong> permite unificar toda la información en una sola plataforma,
                estructurada y accesible para los perfiles autorizados.
              </p>
            </div>
          </div>

          {/* Caso 2 */}
          <div className="col-md-6">
            <div className="h-100 p-4 bg-light rounded-4 shadow-sm">
              <h5 className="fw-bold mb-2">
                2. Equipos que gestionan actuaciones CES con varios agentes implicados
              </h5>
              <p className="text-muted mb-0" style={{ lineHeight: 1.7, fontSize: "0.95rem" }}>
                En la gestión de colonias intervienen responsables municipales, voluntariado y profesionales
                veterinarios. La coordinación suele ser un reto cuando cada actor maneja su propio registro.
                <br />
                Con <strong>ONEGAT</strong>, cada rol tiene su propio acceso y permisos, permitiendo documentar
                actuaciones, registrar intervenciones y consultar el historial sin duplicar información.
              </p>
            </div>
          </div>

          {/* Caso 3 */}
          <div className="col-md-6">
            <div className="h-100 p-4 bg-light rounded-4 shadow-sm">
              <h5 className="fw-bold mb-2">
                3. Necesidad de generar informes internos de manera rápida
              </h5>
              <p className="text-muted mb-0" style={{ lineHeight: 1.7, fontSize: "0.95rem" }}>
                Muchos técnicos necesitan elaborar informes periódicos sobre colonias, actuaciones o censos,
                especialmente en épocas de campañas CES o revisiones internas.
                <br />
                <strong>ONEGAT</strong> genera informes a partir de la información registrada, evitando recopilar
                datos manualmente o actualizar hojas de cálculo.
              </p>
            </div>
          </div>

          {/* Caso 4 */}
          <div className="col-md-6">
            <div className="h-100 p-4 bg-light rounded-4 shadow-sm">
              <h5 className="fw-bold mb-2">
                4. Entidades que requieren trazabilidad completa de las actuaciones
              </h5>
              <p className="text-muted mb-0" style={{ lineHeight: 1.7, fontSize: "0.95rem" }}>
                La trazabilidad es esencial para saber qué se hizo, cuándo, quién lo hizo y en qué colonia.
                En muchos municipios esto se registra de forma parcial o informal.
                <br />
                <strong>ONEGAT</strong> mantiene un historial completo de cada intervención, proporcionando
                una visión clara y ordenada para uso interno de la entidad.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* DISCLAIMER LEGAL */}
      <section className="mb-4">
        <div className="alert alert-secondary shadow-sm" role="alert">
          <h2 className="h5 fw-bold mb-2">Qué NO es ONEGAT</h2>
          <p className="mb-1" style={{ fontSize: "0.95rem" }}>
            ONEGAT no presta servicios administrativos, jurídicos ni de mediación.
          </p>
          <p className="mb-1" style={{ fontSize: "0.95rem" }}>
            No interviene en conflictos vecinales ni sustituye funciones municipales.
          </p>
          <p className="mb-0" style={{ fontSize: "0.95rem" }}>
            Es exclusivamente una herramienta tecnológica destinada a la gestión interna de datos por parte de las
            entidades que la utilizan.
          </p>
        </div>
      </section>

      {/* ENLACES RÁPIDOS */}
      <section className="text-center mt-4">
        <p className="text-muted mb-2">¿Quieres saber más?</p>
        <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
          <Link to="/quienes-somos" className="btn btn-outline-primary px-4">
            Sobre Onegat
          </Link>
          <Link to="/contacto" className="btn btn-outline-dark px-4">
            Contacto y solicitud de demo
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HomePreview;
